import React, { useEffect } from "react";
import { Tooltip } from "react-tooltip";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";
import Table from "../../../../components/table/coreUiTable/Table";
import { cuFormat } from "../../../../components/table/coreUiTable/Format";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const PosTable = () => {
  const dispatch = useDispatch();
  const posTableData = useSelector((state) => state.numberOfActiveMembersBy.posTableData);

  useEffect(() => {
    dispatch(actionCreators.fetchPosModalData());
  }, []);

  if (!posTableData?.data) return <LoadingAnimation text="Updating data..." />;

  const addTooltip = (header, formattedValue) => (
    <span data-tooltip-id="pos-table-tooltip-id" data-tooltip-content={formattedValue}>
      {formattedValue}
    </span>
  );

  const formattedSlots = cuFormat({
    customFn: (header, formattedValue) => addTooltip(header, formattedValue),
    headers: posTableData.colHeaders,
    columns: posTableData.columns
  });

  return (
    <div className="pos-table-wrapper">
      <Tooltip id="pos-table-tooltip-id" />

      <Table
        key="pos-table"
        cName="pos-table"
        pagination
        title=" "
        sorter
        showCount
        scopedSlots={{
          ...formattedSlots,
          ["# of Stores"]: (item) => <td style={{ width: "0" }}>{item["# of Stores"]}</td>
        }}
        table={{
          colHeaders: posTableData.colHeaders,
          data: posTableData.data
        }}
      />
    </div>
  );
};

export default PosTable;
